import React from 'react';
import SafeIcon from '../common/SafeIcon';

const tasks = [
  { id: 'TSK-01', name: 'Finalize Pricing Strategy', dept: 'Product', duration: 'Oct 10 - Oct 15', progress: 100 },
  { id: 'TSK-02', name: 'Draft Press Release', dept: 'PR', duration: 'Oct 16 - Oct 25', progress: 100 },
  { id: 'TSK-03', name: 'Record Demo Videos', dept: 'Marketing', duration: 'Oct 20 - Nov 05', progress: 85 },
  { id: 'TSK-04', name: 'Configure CRM Workflows', dept: 'Ops', duration: 'Nov 01 - Nov 10', progress: 40 },
  { id: 'TSK-05', name: 'Live Stream Setup', dept: 'Tech', duration: 'Nov 15 - Nov 22', progress: 0 },
];

const Timeline = () => {
  return (
    <div className="space-y-6 max-w-7xl mx-auto">
      <div className="mb-8">
        <h2 className="text-2xl font-bold text-ice">Flight Path</h2>
        <p className="text-sm text-slate-400 font-mono mt-1">DEPENDENCY MATRIX</p>
      </div>

      <div className="glass-panel rounded-xl overflow-hidden border border-slate-800">
        <div className="overflow-x-auto">
          <table className="w-full text-left border-collapse">
            <thead>
              <tr className="bg-slate-900/80 border-b border-slate-800 text-xs font-mono text-slate-400 uppercase tracking-wider">
                <th className="p-4 font-medium">Task ID</th>
                <th className="p-4 font-medium">Objective</th>
                <th className="p-4 font-medium">Squad</th>
                <th className="p-4 font-medium">Window</th>
                <th className="p-4 font-medium w-1/4">Completion</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-800/50">
              {tasks.map((task) => (
                <tr key={task.id} className="hover:bg-slate-800/30 transition-colors">
                  <td className="p-4 text-xs font-mono text-rocket-500">{task.id}</td>
                  <td className="p-4 text-sm text-ice font-medium">{task.name}</td>
                  <td className="p-4">
                    <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-slate-800 text-slate-300">
                      {task.dept}
                    </span>
                  </td>
                  <td className="p-4 text-xs text-slate-400 font-mono">{task.duration}</td>
                  <td className="p-4">
                    <div className="flex items-center space-x-3">
                      <div className="w-full bg-slate-800 rounded-full h-1.5 overflow-hidden">
                        <div 
                          className={`h-1.5 rounded-full ${task.progress === 100 ? 'bg-green-500' : 'bg-rocket-500 shadow-[0_0_8px_rgba(249,115,22,0.6)]'}`} 
                          style={{ width: `${task.progress}%` }}
                        ></div>
                      </div>
                      <span className="text-xs font-mono text-slate-400 min-w-[3ch]">{task.progress}%</span>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Timeline;